import { createFileRoute } from '@tanstack/react-router';

import { AbstractCreate } from '@/module/Author/Abstract/AbstractCreate';

export const Route = createFileRoute('/_auth/author/_author/abstract/_abstract/create')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  return <AbstractCreate />;
}
